<template>
  <div class="wrapper">
    <div class="filter-title">{{ title }}</div>

    <DatePicker v-model="range" :model-config="modelConfig" :update-on-input="true" is-range />

    <div class="filter-operation">
      <UiButton :class="['button', 'is-small', 'is-blue']" @click="confirm"> Применить </UiButton>
      <UiButton :class="['button', 'is-small', 'is-light']" @click="reset"> Очистить </UiButton>
    </div>
  </div>
</template>

<script>
import common from './common'

export default {
  components: {
    DatePicker: () => import('v-calendar/lib/components/date-picker.umd'),
    UiButton: () => import('@/components/UiButton.vue'),
  },
  mixins: [common],
  data() {
    return {
      range: {
        start: '',
        end: '',
      },
      modelConfig: {
        type: 'string',
        mask: 'DD-MM-YYYY',
      },
    }
  },
  computed: {
    keyStart() {
      return this.queryKey + '_start'
    },
    keyEnd() {
      return this.queryKey + '_end'
    },
  },
  watch: {
    '$route.query': {
      handler: 'setQueryDate',
      immediate: true,
    },
  },
  methods: {
    reset() {
      this.updateQueryParams({
        query: { ...this.$query, page: null, [this.keyStart]: null, [this.keyEnd]: null },
      })

      this.closeFn()
    },

    confirm() {
      this.updateQueryParams({
        query: {
          ...this.$query,
          page: null,
          [this.keyStart]: this.range.start,
          [this.keyEnd]: this.range.end,
        },
      })

      this.closeFn()
    },

    setQueryDate() {
      const start = this.$query[this.keyStart]
      const end = this.$query[this.keyEnd]

      this.range = { start, end }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  @include createFlex(flexbox, nowrap, column, flex-start, stretch, stretch);

  .vc-container {
    border: none !important;
  }
}
</style>
